// /stores/WheelAnalysis/allGoals.js
import { defineStore } from 'pinia'
import { useCriticalGoalsStore } from '@/stores/WheelAnalysis/criticalGoals'
import { useAnalysisStore } from '@/stores/Setup/analysis'
import useWheelAnalysisQuery from '@/composables/useWheelAnalysisQuery'
import axios from 'axios'

export const useAllGoalsStore = defineStore('allGoals', {
    state: () => ({
        hydratedOnce: false,
        primaryGoalsViewMode: null,
        reviewNotes: null,
        isHydrating: false, // <— NEW

        selectedGoals: [false,false,false,false,false,false,false,false,false,false,true,false,false,false,false,false,false],

        selectedTargets: Array.from({ length: 28 }, () =>
            Array.from({ length: 19 }, () => false)
        ),
    }),

    actions: {
        setSelectedTargetLocal(goalIdx, targetIdx, value) {
            const rowCopy = [...this.selectedTargets[goalIdx]]
            rowCopy[targetIdx] = !!value
            this.selectedTargets.splice(goalIdx, 1, rowCopy)
        },

        setSelectedTargets(next) {
            this.selectedTargets = (next || []).map(row => [...row])
            this.selectedTargetsChanged()
        },

        updateSelectedGoals() {
            const critical = useCriticalGoalsStore()
            this.selectedGoals = [...critical.selectedCriticalGoals]
            this.selectedGoalsChanged()
        },

        async fetchWheelAnalysis() {
            await useWheelAnalysisQuery()
        },

        // Legacy saves (kept) — now skip when hydrating
        selectedGoalsChanged() {
            if (this.isHydrating) return
            const analysisStore = useAnalysisStore()
            this.saveAllGoalsGoals(analysisStore.wheelAnalysisId)
        },

        selectedTargetsChanged() {
            if (this.isHydrating) return
            const analysisStore = useAnalysisStore()
            this.saveAllGoalsTargets(analysisStore.wheelAnalysisId)
        },

        // Explicit saves
        saveAllGoalsGoals(wheelId) {
            if (!wheelId) return console.warn('[allGoals] saveAllGoalsGoals skipped: wheelId missing')
            const payload = { all_goals_selected_goals: JSON.stringify(this.selectedGoals) }
            axios.put(`${process.env.VUE_APP_API_ROOT}api/v1/wheel_analyses/${wheelId}/all_goals_selected_goals`, payload)
                .then(r => console.log('Saved all_goals_selected_goals', r.status))
                .catch(e => console.error('Save failed (goals):', e))
        },

        saveAllGoalsTargets(wheelId) {
            if (!wheelId) return console.warn('[allGoals] saveAllGoalsTargets skipped: wheelId missing')
            const payload = { all_goals_selected_targets: JSON.stringify(this.selectedTargets) }
            axios.put(`${process.env.VUE_APP_API_ROOT}api/v1/wheel_analyses/${wheelId}/all_goals_selected_targets`, payload)
                .then(r => console.log('Saved all_goals_selected_targets', r.status))
                .catch(e => console.error('Save failed (targets):', e))
        },

        reviewNotesChanged() {
            const analysisStore = useAnalysisStore()
            if (analysisStore.wheelAnalysisId == null) return
            axios.put(
                `${process.env.VUE_APP_API_ROOT}api/v1/wheel_analyses/${analysisStore.wheelAnalysisId}/notes`,
                { notes: this.reviewNotes ?? '' }
            ).then(r => console.log('Saved notes', r.status))
                .catch(e => console.error('Save failed (notes):', e))
        }
    },

    persist: true
})
